import { BudgetCategoryDOtherCosts } from '../../../features/feature-budget/models/interfaces/budget-category-d-data.interface'
import { BudgetCostsPerWp } from '../../../features/feature-budget/models/interfaces/budget-costs-per-wp.interface'
import { BudgetEffort } from '../../../features/feature-budget/models/interfaces/budget-effort.interface'
import { BudgetIncome } from '../../../features/feature-budget/models/interfaces/budget-income.interface'
import { BudgetJustificationOfCostsResult } from '../../../features/feature-budget/models/interfaces/budget-justification-of-costs.interface'
import { BudgetJustificationPartner } from '../../../features/feature-budget/models/interfaces/budget-justification-partner.interface'
import { BudgetSalary } from '../../../features/feature-budget/models/interfaces/budget-salary.interface'
import { BudgetStaffEffort } from '../../../features/feature-budget/models/interfaces/budget-staff-effort.interface'
import { BudgetWorkPackage } from '../../../features/feature-budget/models/interfaces/budget-workpackage.interface'
import { BudgetWpWeight } from '../../../features/feature-budget/models/interfaces/budget-wp-weight.interface'
import { AppProgressbarState } from '../../models/interfaces/app-progressbar-state.interface'

export interface BudgetState {
   exportProgress?: AppProgressbarState
   salary?: BudgetSalary
   isLoadingSalary?: boolean
   effort?: BudgetEffort
   isLoadingEffort?: boolean
   income?: BudgetIncome[]
   isLoadingIncome?: boolean
   staffEffort?: BudgetStaffEffort[]
   isLoadingStaffEffort?: boolean
   wpWeight?: BudgetWpWeight[]
   isLoadingWpWeight?: boolean
   workPackages?: BudgetWorkPackage[]
   isLoadingWorkPackages?: boolean
   costsPerWp?: BudgetCostsPerWp[]
   isLoadingCostsPerWp?: boolean
   partners?: BudgetJustificationPartner[]
   isLoadingPartners?: boolean
   justificationOfCosts?: BudgetJustificationOfCostsResult
   isLoadingJustificationOfCosts?: boolean
   categoryDOtherCosts?: BudgetCategoryDOtherCosts[]
   isLoadingCategoryDOtherCosts?: boolean
}

export const initialBudgetState: BudgetState = {}
